import * as z from 'zod';
import { zEmail } from '../error-messages';

export const updatePersonalEmailFormSchema = z.object({
  email: zEmail,
});

export type UpdatePersonalEmailForm = z.TypeOf<
  typeof updatePersonalEmailFormSchema
>;
